export const notificationOptions = { allowRedirect: true, dontGrayscalePage: true };
